import {
  map,
  prop,
  head,
  has,
  fromPairs,
  curryN,
  filter,
  flatten,
  join,
  identity,
  compose,
  length,
  zipObj,
} from "ramda";
import { scrollToElement } from "../helpers";

// Like ramda/mergeWithKey but return object when key in both objects exists
const mergeWithKeyOnly = curryN(3, (fn, l, r) => {
  const result = {};
  let k;

  for (k in l) {
    if (has(k, l) && has(k, r)) {
      result[k] = fn(k, l[k], r[k]);
    }
  }

  return result;
});

export const getIdsForValidation = compose(
  map((item) => item.id),
  filter((item) => item.validation),
  flatten,
  map((item) => item.data),
);

export const mapConfigToValidation = compose(
  fromPairs,
  map((item) => [item.id, item.validation]),
  filter((item) => item.validation),
  filter((item) => item.visible !== false),
  flatten,
  map((item) => item.data),
);

const getInvalidFormFields = (validationResult, formConfig) =>
  getIdsForValidation(formConfig).filter((fieldName) =>
    prop(fieldName, validationResult),
  );

const getInvalidFormState = (invalidFields) =>
  zipObj(invalidFields, Array(length(invalidFields)).fill(false));

export const isFormValid = (props, formConfig) => {
  const validationResult = getErrors(
    props.formState,
    mapConfigToValidation(formConfig),
  );
  const invalidFields = getInvalidFormFields(validationResult, formConfig);
  props.setValid(getInvalidFormState(invalidFields));

  if (length(invalidFields)) {
    scrollToElement(head(invalidFields));
    return false;
  }

  return true;
};

const createPredicate =
  ([isValid, errorMsg, required]) =>
  (value) =>
    value ? (isValid(value) ? null : errorMsg) : !required ? null : errorMsg;

const createPredicates = map(createPredicate);
const runPredicates = ([input, validations]) =>
  map((predFn) => predFn(input), createPredicates(validations));
const validate = map((data) =>
  join(" ", filter(identity, runPredicates(data))),
);
const makeValidationObject = mergeWithKeyOnly((k, l, r) => [l, r]);
export const getErrors = compose(validate, makeValidationObject);
